module.exports = __webpack_public_path__ + "static/weekendcycler-7dd49bf15c6ee1ff7e3c223792da4019.jpg";